import { find, get, isEmpty } from 'lodash';

const getNetworkServiceTypes = (user, networkId) => {
  const selectedNetwork = find(user.networks, { id: networkId }) || {};
  return selectedNetwork.service_types || [];
};

const getProgramServiceTypes = (programsServiceTypes, program) => {
  const programId = program?.id;
  return !isEmpty(program) && programId ? get(programsServiceTypes, programId, []) : [];
};

export default function getServiceTypeOptions({
  defaultProgramSelected, fields, programsServiceTypes, user,
}) {
  if (defaultProgramSelected) {
    return getNetworkServiceTypes(user, fields?.network?.id);
  }
  return getProgramServiceTypes(programsServiceTypes, fields?.program);
}
